module.exports = __webpack_public_path__ + "img/matic-token.6935d4ad.png";